import { parseCommaList } from "./utils"

/** Preset hiring regions for HSRFC community jobs. */
export const HIRING_REGION_PRESETS = [
  "HSR",
  "Koramangala",
  "JP Nagar",
  "Whitefield",
  "Sarjapur",
  "Bangalore",
  "Remote",
] as const

export type HiringRegionPreset = (typeof HIRING_REGION_PRESETS)[number]

export function parseRegions(value: string): string[] {
  return parseCommaList(value)
}

export function formatRegions(regions: string[]): string {
  return regions.join(", ")
}

export function toggleRegion(current: string, region: string): string {
  const list = parseRegions(current)
  if (list.includes(region)) {
    return formatRegions(list.filter((r) => r !== region))
  }
  return formatRegions([...list, region])
}

/** Best-effort map from a free-text location to a preset pill. */
export function inferRegionFromLocation(location: string): string | undefined {
  const lower = location.trim().toLowerCase()
  if (!lower) return undefined
  if (lower.includes("remote")) return "Remote"
  for (const region of HIRING_REGION_PRESETS) {
    if (region === "Bangalore") {
      if (lower.includes("bangalore") || lower.includes("bengaluru")) return region
      continue
    }
    if (region === "Remote") continue
    if (lower.includes(region.toLowerCase())) return region
  }
  return undefined
}

export function regionOptions(current: string): string[] {
  const selected = parseRegions(current)
  const presetSet = new Set<string>(HIRING_REGION_PRESETS)
  const custom = selected.filter((r) => !presetSet.has(r))
  return [...HIRING_REGION_PRESETS, ...custom]
}

/** Filter jobs/candidates by selected hiring-region presets. */
export function matchesHiringRegions(
  subject: { remoteRegions?: string[]; location?: string },
  selected: string[],
): boolean {
  if (selected.length === 0) return true
  const regions = subject.remoteRegions ?? []
  const loc = (subject.location ?? "").toLowerCase()
  return selected.some((region) => {
    if (regions.includes(region)) return true
    if (region === "Bangalore") {
      return loc.includes("bangalore") || loc.includes("bengaluru")
    }
    if (region === "Remote") {
      return loc.includes("remote")
    }
    return loc.includes(region.toLowerCase())
  })
}
